<template>
  <div class="partner-individuals-container">
    <div class="partner-statements-badge">{{ getTestimonials.badge }}</div>
    <div class="partner-individuals-title">{{ getTestimonials.title }}</div>
    <div class="partner-individuals-desc">
      {{ getTestimonials.description }}
    </div>
    <div class="row">
      <div class="col-lg-6 col-12">
        <div
          class="partner-individuals-wrapper"
          v-for="(slide, i) in getTestimonials.items"
          :class="i === activeTestimonial ? '' : 'hidden'"
          :key="i"
        >
          <div class="individual-testimonial-container">
            <i class="mdi mdi-format-quote-open testimonial-quotes"></i>
            <div class="partner-individuals-text">
              {{ slide.text }}
            </div>
            <div class="d-flex align-center">
              <img
                :src="slide.image"
                class="partner-individuals-logos"
                alt="partner thumbnail"
              />
              <div class="ml-3">
                <div class="partner-individuals-inner-name">
                  {{ slide.title }}
                </div>
                <div class="partner-individuals-inner-title">
                  {{ slide.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="individuals-navigation">
          <div
            class="partner-statements-navigation-buttons swiper-button-prev"
            @click="changeTestimonial('prev')"
          >
            <i class="mdi mdi-arrow-left"></i>
          </div>
          <div
            class="partner-statements-navigation-buttons swiper-button-next"
            @click="changeTestimonial('next')"
          >
            <i class="mdi mdi-arrow-right"></i>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div
          class="partner-individuals-wrapper-left"
          v-for="(slide, i) in nextThreeTestimonials"
          :key="i"
        >
          <div class="individual-testimonial-container">
            <div class="partner-individuals-text-left">
              {{ slide.text }}
            </div>
            <div class="d-flex align-center">
              <div class="partner-individuals-inner-name mr-3">
                {{ slide.title }}
              </div>
              <div class="partner-individuals-inner-title">
                {{ slide.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5">
      <md-filled-tonal-button
        class="get-started-button"
        @click="$router.push('/book-demo')"
      >
        Start Your Free Trial Now
        <i class="mdi mdi-arrow-right"></i>
      </md-filled-tonal-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "individualCourses",
  components: {},
  data() {
    return {
      activeTestimonial: 0,
    };
  },
  props: ["getTestimonials"],
  computed: {
    nextThreeTestimonials() {
      const start = this.activeTestimonial + 1;
      const end = start + 3;
      return this.getTestimonials.items
        .slice(start, end)
        .concat(
          this.getTestimonials.items.slice(
            0,
            Math.max(0, end - this.getTestimonials.items.length)
          )
        );
    },
  },
  methods: {
    changeTestimonial(direction) {
      if (direction === "next") {
        if (this.activeTestimonial === this.getTestimonials.items.length - 1) {
          this.activeTestimonial = 0;
        } else {
          this.activeTestimonial++;
        }
      } else {
        if (this.activeTestimonial === 0) {
          this.activeTestimonial = this.getTestimonials.items.length - 1;
        } else {
          this.activeTestimonial--;
        }
      }
    },
  },
};
</script>

<style></style>
